import { render } from "./DividerStoryComponent.vue?vue&type=template&id=60d69128&scoped=true"
import script from "./DividerStoryComponent.vue?vue&type=script&lang=js"
export * from "./DividerStoryComponent.vue?vue&type=script&lang=js"

import "./DividerStoryComponent.vue?vue&type=style&index=0&id=60d69128&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d69128"]])

export default __exports__